import { Component, OnInit } from '@angular/core';
import { HoaDocument } from 'app/models/HOA/hoa-document';
import { LeaseCard } from '../../models/leasecard';
import { Router, ActivatedRoute } from '@angular/router';
import { LeaseService } from '../../../services/lease.service';
import { ApplicationDataService } from '../../../services/application.service';
import { AccountService } from '../../../services/account.service';
import { ErrorService } from '../../../services/error.service';
import { RentalLeaseStatus } from 'enumerations/rental-lease-status';

@Component({
  selector: 'app-non-legacy-leases-dashboard',
  templateUrl: './non-legacy-leases-dashboard.component.html',
  styleUrls: ['./non-legacy-leases-dashboard.component.css']
})
export class NonLegacyLeasesDashboardComponent implements OnInit {

  errorMessage: string = null;
  leases: LeaseCard[] = [];
  hoaDocuments: HoaDocument[] = [];

  constructor(private router: Router, 
              private route: ActivatedRoute, 
              private accountService: AccountService, 
              private leaseService: LeaseService, 
              private applicationService: ApplicationDataService,
              private errorService: ErrorService
  ) {

    localStorage.removeItem('RentalLeaselKey');

    this.leaseService.getLeasesForDashboard()
      .subscribe(res => this.onGetLeasesForDashboard(res), res => this.leaseService.handleError("Error pulling non-legacy lease records."));
  }

  ngOnInit() {
    this.getResidentStatus();
  }

  getResidentStatus() {
    this.accountService.getResidentStatus()
      .subscribe(res => this.onGetResidentStatusSuccess(res), err => this.accountService.handleError(err));
  }
  onGetResidentStatusSuccess(res) {
    if (!res) {
      this.router.navigate(['/application/dashboard']);
    }
  }

  async onGetLeasesForDashboard(returnedLeases: LeaseCard[]) {
    this.leases = returnedLeases;

    for (const lease of this.leases) {
      let prop = await this.applicationService.getProperty(lease.YardiKey).toPromise();
      lease.PropViewCard = { ...prop.results[0], sqft: `${prop.results[0].sqft}` };
      lease.PropViewCard.sqft = lease.PropViewCard.sqft.toLocaleString();
      lease.PropViewCard.rent = lease.PropViewCard.rent.toLocaleString();
      
      if (lease.HasHoa && this.hasAnActiveStatus(lease.Status)) {
        this.leaseService.getHoaDocuments(lease.RentalLeaseKey)
                         .subscribe(
                          (res) => this.onGetHoaDocuments(res, lease.PropViewCard.thumb),
                          (err) => this.onGetHoaDocumentsError(err)
                         );
      }
    }
  }

  hasAnActiveStatus(status: RentalLeaseStatus): boolean {
    if ([RentalLeaseStatus.Active, RentalLeaseStatus.LeaseRenewed, 
         RentalLeaseStatus.MTM, RentalLeaseStatus.OnNotice].includes(status)) {
      return true;
    }
    return false;
  }

  onGetHoaDocuments(docs: HoaDocument[], imageUrl: string = "../../../assets/images/FallbackImage_House.jpg") {
    docs.forEach(d => {
      if (d.imageUrl === null || d.imageUrl.length < 1) {
        d.imageUrl = imageUrl
      }
      this.hoaDocuments.push(d)
    })
  }

  onGetHoaDocumentsError(error: Error) {
    this.showErrorMessage(`HOA Documents Not Found\n\nError: ${error.message ?? 'Unknown'}`)
  }

  processError(err: Error) {
    this.showErrorMessage(err.message)
  }

  openNewTab(url: string) {
    if (/^https:/.test(url)) {
      window.open(url, "_blank");
    } else {
      this.errorService.showError("URL Invalid")
    }
  }

  downloadAndOpenLease(card: LeaseCard) {
    localStorage.setItem('RentalLeaselKey', card.RentalLeaseKey.toString());
    this.leaseService.getLeaseDocument(card.RentalLeaseKey)
      .subscribe(res => this.openNewTab(res), err => this.showErrorMessage(err.error));
  }

  showErrorMessage(error: string) {
    this.errorService.showError(error);
  }
}
